<template>
  <cv-grid id="bottoniera" full-width>
    <cv-row>
       <!-- Per schermi medi e grandi -->
       <cv-column :sm="0" :md="8" :lg="11">
          <cv-button kind="primary" :icon="svg_nuovo" v-show="mettiBtnAggiungiBlu()"
                     @click="$emit('nuovo-premuto')">{{ testo_nuovo }}</cv-button>

          <cv-button kind="primary" :icon="svg_salva" v-show="mettiBtnSalvaBlu()"
                     @click="$emit('salva-premuto')">{{testo_salva}}</cv-button>
          <cv-button kind="ghost" :icon="svg_nuovo" v-show="mettiBtnAggiungiGhost()"
                     @click="$emit('nuovo-premuto')" />

         <cv-tooltip tip="Duplica">
           <cv-button kind="ghost" :icon="svg_duplica" v-show="mettiBtnDuplica()"
                      @click="$emit('duplica-premuto')"/>
         </cv-tooltip>
          <cv-tooltip tip="Primo">
            <cv-button kind="ghost" tip="Primo Record" :icon="svg_primo" v-show="!primo"
                       @click="$emit('primo-premuto')"></cv-button>
          </cv-tooltip>
          <cv-tooltip tip="Precedente">
            <cv-button kind="ghost" :icon="svg_precedente" v-show="!primo"
                       @click="$emit('precedente-premuto')"/>
          </cv-tooltip>
          <cv-tooltip tip="Successivo">
            <cv-button kind="ghost" :icon="svg_successivo" v-show="!ultimo"
                       @click="$emit('successivo-premuto')"/>
          </cv-tooltip>
          <cv-tooltip tip="Ultimo">
            <cv-button kind="ghost" :icon="svg_ultimo" v-show="!ultimo"
                       @click="$emit('ultimo-premuto')"/>
          </cv-tooltip>
          <cv-tooltip tip="cambia visualizzazione">
            <cv-button kind="ghost" :icon="svg_change_view"
                       @click="$emit('visualizzazione-premuto')"/>
          </cv-tooltip>
          <cv-tooltip tip="Cerca dati per questa maschera">
            <cv-button kind="ghost" :icon="svg_binoculars"
                       @click="$emit('filtra-premuto')"/>
          </cv-tooltip>
          <cv-tooltip tip="Cancella questo record">
            <cv-button style="color: red" kind="ghost" :icon="svg_cestino"
                       @click="$emit('cancella-premuto')"/>
          </cv-tooltip>
      </cv-column>
      <!-- non generiche -->
      <cv-column :sm="0" :md="8" :lg="5">
        <slot name="btn1"></slot>
        <slot name="btn2"></slot>
      </cv-column>

      <!-- Per schermi piccoli -->
      <cv-column :sm="4" :md="0" :lg="0">
        <cv-button kind="primary" :icon="svg_nuovo" v-show="mettiBtnAggiungiBlu()"
                   @click="$emit('primo-premuto')">{{testo_nuovo}}</cv-button>

        <cv-button kind="primary" :icon="svg_salva" v-show="mettiBtnSalvaBlu()"
                   @click="$emit('salva-premuto')">{{testo_salva}}</cv-button>
        <cv-button kind="ghost" :icon="svg_nuovo" v-show="mettiBtnAggiungiGhost()"
                   @click="$emit('nuovo-premuto')" />
        <cv-tooltip tip="Duplica">
          <cv-button kind="ghost" :icon="svg_duplica" v-show="mettiBtnDuplica()"
                     @click="$emit('duplica-premuto')" />
        </cv-tooltip>
      </cv-column>
      <cv-column :sm="4" :md="0" :lg="0">
        <cv-tooltip tip="Primo">
          <cv-button kind="ghost" tip="Primo Record" :icon="svg_primo" v-show="!primo"
                     @click="$emit('primo-premuto')"></cv-button>
        </cv-tooltip>
        <cv-tooltip tip="Precedente">
          <cv-button kind="ghost" :icon="svg_precedente" v-show="!primo"
                     @click="$emit('precedente-premuto')"/>
        </cv-tooltip>
        <cv-tooltip tip="Successivo">
          <cv-button kind="ghost" :icon="svg_successivo" v-show="!ultimo"
                     @click="$emit('successivo-premuto')"/>
        </cv-tooltip>
        <cv-tooltip tip="Ultimo">
          <cv-button kind="ghost" :icon="svg_ultimo" v-show="!ultimo"
                     @click="$emit('ultimo-premuto')" />
        </cv-tooltip>
      </cv-column>
      <cv-column :sm="4" :md="0" :lg="0">
        <cv-tooltip tip="cambia visualizzazione">
          <cv-button kind="ghost" :icon="svg_change_view"
                     @click="$emit('visualizzazione-premuto')"/>
        </cv-tooltip>
        <cv-tooltip tip="Cerca dati per questa maschera">
          <cv-button kind="ghost" :icon="svg_binoculars"
                     @click="$emit('filtra-premuto')"/>
        </cv-tooltip>
        <cv-tooltip tip="Cancella questo record">
          <cv-button style="color: red" kind="ghost" :icon="svg_cestino"
                     @click="$emit('cancella-premuto')"/>
        </cv-tooltip>
      </cv-column>
      <cv-column :sm="4" :md="0" :lg="0">
        <slot name="btn1"></slot>
      </cv-column>
      <cv-column :sm="4" :md="0" :lg="0">
        <slot name="btn2"></slot>
      </cv-column>
    </cv-row>
  </cv-grid>
</template>

<script>
import Add from '@carbon/icons-vue/es/add/16';
import Copy from '@carbon/icons-vue/es/copy/16';
import PageFirst from '@carbon/icons-vue/es/page--first/16';
import ChevronLeft from '@carbon/icons-vue/es/chevron--left/16';
import ChevronRight from '@carbon/icons-vue/es/chevron--right/16';
import PageLast from '@carbon/icons-vue/es/page--last/16';
import Trash from '@carbon/icons-vue/es/trash-can/16';
import Save from '@carbon/icons-vue/es/save/16';
import Table from '@carbon/icons-vue/es/table/16';
import Binoculars from '@carbon/icons-vue/es/binoculars/16';

export default {
  name: "Bottoniera",
  components: { },
  props: {
    testo_nuovo: {
      type: String,
      required: true
    },
    testo_salva: {
      type: String,
      required: true,
    },
    stato: {
      type: Number,
      required: true
    },
    primo: {
      type: Boolean,
      required: false,
      default: false
    },
    ultimo: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      aiutino: "Cancella",

      // icone dei bottoni
      svg_nuovo: Add,
      svg_duplica: Copy,
      svg_primo: PageFirst,
      svg_precedente: ChevronLeft,
      svg_successivo: ChevronRight,
      svg_ultimo: PageLast,
      svg_cestino: Trash,
      svg_salva: Save,
      svg_change_view: Table,
      svg_binoculars: Binoculars,
    }
  },
  methods: {
    mettiBtnSalvaBlu: function () {
      return this.stato === this.$statiPossibili.modificato;
    },
    mettiBtnAggiungiBlu: function () {
      return this.stato === this.$statiPossibili.non_modificato;
    },
    mettiBtnAggiungiGhost: function() {
      return this.stato === this.$statiPossibili.modificato;
    },
    mettiBtnDuplica: function () {
      return this.stato === this.$statiPossibili.non_modificato;
    },
    actionClose: function () {
      this.notifica_visibile = false;
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/carbon';

#bottoniera {
  background-color: $ui-background;
}
</style>